export default __webpack_public_path__ + "static/media/2_0086.4e02520b.webp";